import PropTypes from 'prop-types';
import React, { useState } from 'react';

// Collapsible facet section with a count badge.
const Section = ({ title, badge, defaultOpen = false, children }) => {
  const [open, setOpen] = useState(defaultOpen);
  return (
    <div className="ab-section">
      <button type="button" className="ab-section__head" aria-expanded={open} onClick={() => setOpen((o) => !o)}>
        <span className="ab-section__title">
          {title}
          {badge > 0 && <span className="ab-badge">{badge}</span>}
        </span>
        <svg className={`ab-chevron ${open ? 'ab-chevron--open' : ''}`} width="18" height="18" viewBox="0 0 24 24"
          fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
          <path d="M6 9l6 6 6-6" />
        </svg>
      </button>
      {open && <div className="ab-section__body">{children}</div>}
    </div>
  );
};
Section.propTypes = {
  title: PropTypes.string.isRequired,
  badge: PropTypes.number,
  defaultOpen: PropTypes.bool,
  children: PropTypes.node.isRequired,
};

export default Section;
